import React, { useState } from 'react';
import styled from 'styled-components';
import { useAnalytics } from '../context/AnalyticsContext';

// Styled component for the container
const Container = styled.div`
  /* max-width: 400px; */
  margin: 0 auto;
`;

// Styled component for the content
const Content = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
`;

// Styled component for the "Read More" button
const ReadMoreButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-brand-700);
  &:focus{
    outline: none;
  }
`;

const ReadMore = ({ htmlContent, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { trackButtonClick } = useAnalytics();

  // Toggle between expanded and collapsed modes
  const toggleExpanded = () => {
    trackButtonClick("Read more");
    setIsExpanded(!isExpanded);
  };

  return (
    <Container>
      <Content>
        {isExpanded ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: `${htmlContent.slice(0, maxLength)}...` }} />
        )}
      </Content>
      {htmlContent.length > maxLength && (
        <ReadMoreButton onClick={toggleExpanded}>
          {isExpanded ? 'Read Less' : 'Read More'}
        </ReadMoreButton>
      )}
    </Container>
  );
};

export default ReadMore;
